import React, { useState } from 'react';
import { Col, Image, Row, Space, Tag, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

import CustomTable from 'src/components/common/CustomTable';
import CustomButton from 'src/components/common/CustomButton';
import ClassRoomModal from 'src/components/Modal/ClassRoomModal';
import MessageForm from 'src/components/DashBoard/SubPage/MessageForm';
import { HRLine } from 'src/components/common/Styles';
import {
  HeaderTitle,
  HalfWrapper,
  StudentHalfWrapper,
  DetailContents,
} from 'src/components/common/Styles';

import * as dummy from 'src/dummy';

const { Title } = Typography;

const Purchase = () => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setVisible(false);
      setLoading(false);
    }, 3000);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <HeaderTitle level={4}>구매 관리</HeaderTitle>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <HalfWrapper>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 10,
              }}
            >
              <div>
                <CustomButton style={{ marginRight: 10 }} onClick={showModal}>
                  등록
                </CustomButton>
              </div>
            </div>

            <CustomTable
              dataSource={dummy.board.ConsultingsList}
              columns={columns}
              pagination={{ pageSize: 12 }}
              size="small"
              color="#edf3fb"
              scroll={{ x: 400 }}
            />

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <CustomButton style={{ marginRight: 10 }} onClick={showModal}>
                회원 상담 등록
              </CustomButton>

              <CustomButton style={{ marginRight: 10 }} onClick={showModal}>
                비회원 상담 등록
              </CustomButton>
            </div>
          </HalfWrapper>
        </Col>

        <Col span={12}>
          <StudentHalfWrapper>
            <div style={{ background: '#ECF1F3', padding: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Title level={5}>학생이름</Title>
                <div>
                  <p>
                    <Tag color="green">구매신청</Tag>
                    2020-00-00 00:00:00
                  </p>
                </div>
              </div>

              <div style={{ display: 'flex' }}>
                <Col span={12}>
                  <div style={{ display: 'flex' }}>
                    <DetailContents width={50} size={0.9} color={'#777777'}>
                      학생연락처
                    </DetailContents>
                    <DetailContents width={100} color={'#202020'}>
                      010-0000-0000
                    </DetailContents>
                  </div>
                </Col>
                <Col span={12}>
                  <div style={{ display: 'flex' }}>
                    <DetailContents width={60} size={0.9} color={'#777777'}>
                      학부모연락처
                    </DetailContents>
                    <DetailContents width={100} color={'#202020'}>
                      010-0000-0000
                    </DetailContents>
                  </div>
                </Col>
              </div>

              <div style={{ display: 'flex' }}>
                <div>
                  <Image
                    width={92}
                    height={120}
                    src="error"
                    fallback="data:image/png;base64,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"
                  />
                </div>

                <div style={{ width: '100%' }}>
                  <Col span={24}>
                    <div style={{ display: 'flex' }}>
                      <DetailContents size={1} color={'#202020'}>
                        교재명
                      </DetailContents>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div style={{ display: 'flex' }}>
                      <DetailContents size={0.9} color={'#202020'}>
                        목록
                      </DetailContents>
                    </div>
                  </Col>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <CustomButton
                      style={{ marginRight: 10, background: '#ECF1F3' }}
                      onClick={showModal}
                    >
                      학생정보 바로가기
                    </CustomButton>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ margin: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Title level={5}>레벨테스트 결과</Title>
                <div>
                  <CustomButton style={{ marginRight: 10 }} onClick={showModal}>
                    교재 지정
                  </CustomButton>
                  <CustomButton>반 지정</CustomButton>
                </div>
              </div>
            </div>

            <Row justify="space-around">
              <Col span={5}>
                <div style={{ display: 'flex' }}>
                  <DetailContents size={0.9} color={'#777777'}>
                    예상 레벨
                  </DetailContents>
                  <DetailContents color={'#202020'}>00</DetailContents>
                </div>
              </Col>
              <Col span={5}>
                <div style={{ display: 'flex' }}>
                  <DetailContents size={0.9} color={'#777777'}>
                    시험 레벨
                  </DetailContents>
                  <DetailContents color={'#202020'}>00</DetailContents>
                </div>
              </Col>

              <Col span={5}>
                <div style={{ display: 'flex' }}>
                  <DetailContents size={0.9} color={'#777777'}>
                    시험 점수
                  </DetailContents>
                  <DetailContents color={'#202020'}>00</DetailContents>
                </div>
              </Col>

              <Col span={5}>
                <div style={{ display: 'flex' }}>
                  <DetailContents size={0.9} color={'#777777'}>
                    결과 레벨
                  </DetailContents>
                  <DetailContents color={'#202020'}>00</DetailContents>
                </div>
              </Col>
            </Row>
            <Row style={{ margin: 10 }}>
              <Col span={24}>
                <DetailContents size={0.8} color={'#777777'}>
                  2020-00-00 00:00:00 ~ 2020-00-00 00:00:00
                </DetailContents>
              </Col>
            </Row>

            <hr />

            <div>
              <Col
                span={24}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <DetailContents size={0.8} color={'#777777'}>
                  2020-00-00 00:00:00
                </DetailContents>
                <DetailContents size={0.8} color={'#777777'}>
                  담당자명
                </DetailContents>
              </Col>

              <div>
                <Col span={24}>
                  <DetailContents size={1} color={'#777777'}>
                    담당자 지정 (담당자명)
                  </DetailContents>
                </Col>
              </div>
            </div>
            <HRLine />
            <div>
              <Col
                span={24}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <DetailContents size={0.8} color={'#777777'}>
                  2020-00-00 00:00:00
                </DetailContents>
                <DetailContents size={0.8} color={'#777777'}>
                  담당자명
                </DetailContents>
              </Col>

              <div>
                <Col span={24}>
                  <DetailContents size={1} color={'#777777'}>
                    레벨테스트 이용권 부여
                  </DetailContents>
                </Col>
              </div>
            </div>

            <div style={{ padding: 5 }}>
              <MessageForm name="등록" minRows={2} />
            </div>
          </StudentHalfWrapper>
        </Col>
      </Row>

      <ClassRoomModal
        visible={visible}
        loading={loading}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
    </>
  );
};

const columns = [
  {
    title: 'No',
    align: 'center',
    dataIndex: 'no',
    width: 40,
  },
  {
    title: '학생이름',
    align: 'center',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '학생ID',
    align: 'center',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '구매종류',
    align: 'center',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: '담당자',
    align: 'center',
    dataIndex: 'manager',
    key: 'manager',
  },
  {
    title: '상태',
    key: 'state',
    align: 'center',
    dataIndex: 'state',
    render: (tags) => (
      <span>
        {tags.map((tag) => {
          let color = 'green';

          if (tag === '진행중') {
            color = 'volcano';
          }
          if (tag === '구매종료') {
            color = 'gray';
          }
          return (
            <Tag color={color} key={tag}>
              {tag.toUpperCase()}
            </Tag>
          );
        })}
      </span>
    ),
  },
  {
    title: '',
    key: 'action',
    fixed: 'right',
    width: 30,
    render: (text, record) => (
      <Space size="middle">
        <a href="#none">
          <CheckCircleOutlined size="Large" />
        </a>
      </Space>
    ),
  },
];

export default Purchase;
